export type ProductVideo = {
  market?: string;
  mainWebShopId?: number;
  productId?: number | string;
  videoId?: number;
  active?: boolean;
  productVideoByLanguage?: Record<string, ProductVideoDetail>;
  productVideoDetail?: ProductVideoDetail;
};

export type ProductVideoDetail = {
  languageCode: string;
  title: string;
  url: string;
  videoFormat: string;
  showOnWebsite?: boolean;
  alignment?: string;
  content?: string;
  image?: string;
  length?: number;
  pictureRank?: number;
  priority?: number;
  subtitle?: string;
  videoMode?: string;
  videoTypeCode?: string;
};
